<template>
  <header class="sticky top-0 z-10 w-full bg-white md:hidden">
    <div class="flex w-full flex-row items-center">
      <Skeleton class="m-4" width="24px" />
      <Skeleton height="24px" width="100px" />
    </div>
  </header>
  <div
    class="mx-auto flex flex-col gap-5 p-5 pb-[9rem] md:grid md:w-[100%] md:grid-cols-[40%_1fr_55%] md:grid-rows-1 md:justify-center md:gap-0 lg:w-[75%]"
  >
    <section class="w-full md:col-span-1">
      <div class="flex w-full flex-col gap-4 md:sticky md:top-[9rem]">
        <!-- Product Image -->
        <div class="hidden h-auto w-full justify-center self-center md:mt-6 md:flex">
          <Skeleton width="80%" height="350px" />
        </div>

        <div class="flex h-auto w-full justify-center self-center md:hidden">
          <Skeleton width="90%" height="250px" />
        </div>
        <div class="hidden md:block md:px-4 lg:px-10">
          <Skeleton width="100%" height="100px" />
        </div>
      </div>
    </section>
    <section class="flex w-full flex-col md:col-start-3 md:col-end-3">
      <!-- Name -->
      <div class="my-4 text-start text-2xl font-bold md:mt-10 md:text-5xl">
        <Skeleton height="50px" width="200px" />
      </div>

      <!-- description -->
      <div class="my-4 text-sm text-mcd-secondaryDarkGrey md:text-base">
        <Skeleton height="100px" width="100%" />
      </div>

      <!-- Sizes -->
      <Skeleton class="mb-4" height="200px" width="100%" />

      <!-- Customization -->
      <Skeleton height="250px" width="100%" />
    </section>
  </div>
</template>
